// src/components/store/sections/faqs/FaqV49TwocolumnboxFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV49TwocolumnboxFuchsiaGlow(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={49}
      archKey="two_column_box"
      archLabel="Two-Column Split Grid"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
